export default "__VITE_ASSET__4f9d2666__"